import { BasicPerson } from '@/components/molecules/user-avatar/user-avatar';

export const getInitials = (person: BasicPerson): string => {
  const firstInitial = person.firstName.trim().charAt(0).toUpperCase();
  const lastInitial = person.lastName.trim().charAt(0).toUpperCase();

  return `${firstInitial}${lastInitial}`;
};
